import axios from 'axios';
import { API_ENDPOINT } from '../../../../index';

import {
	ADD_PROMO,
	DE_ACTIVATE_PROMO,
	SET_PROMO
} from './types';

export const _activatePromo = (promo) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/promotion/payments/activate`,
	data: {
		promo
	}
})

export const _deActivatePromo = (promo) => axios({
	withCredentials: true,
	method: 'post',
	url: `${API_ENDPOINT}/api/admin/promotion/payments/deactivate/${promo._id}`
})

export const _getPromotions = () => axios({
	withCredentials:true,
	url: `${API_ENDPOINT}/api/admin/promotion/payments`
})

export const addPromoToList = ( promo ) => ({
	type: ADD_PROMO,
	promo
})

export const deActivatePromo = (promo) => ({
	type: DE_ACTIVATE_PROMO,
	promo
})

export const setPromotions = ( promos ) => ({
	type: SET_PROMO,
	promotions: promos	
})


// WEBPACK FOOTER //
// ./src/components/promo/payment/actions/index.js